import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const n = () => /* @__PURE__ */ o.jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    d: "M9.00012 7.00012L14.0001 2.00012M10.6668 2.00012H14.0001V5.33346M14.0001 9.33345V12.6668C14.0001 13.0204 13.8596 13.3595 13.6096 13.6096C13.3595 13.8596 13.0204 14.0001 12.6668 14.0001H3.33346C2.97983 14.0001 2.64069 13.8596 2.39065 13.6096C2.1406 13.3595 2.00012 13.0204 2.00012 12.6668V3.33346C2.00012 2.97983 2.1406 2.64069 2.39065 2.39065C2.64069 2.1406 2.97983 2.00012 3.33346 2.00012H6.66679",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) });
export {
  n as E
};
